module.exports = __webpack_public_path__ + "static/media/Barmag 4c2.b0822d39.jpg";